import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';
import BadgeChip from './BadgeChip';
import { distinctBadges, loadUserBadges } from '../utils';
import { t } from '../../../utils/settings';
/**
 * Os emblemas de destaque de alguém, no cartão do usuário:
 * os primeiros na ordem ouro → prata → bronze, e um "+N" que leva à aba
 * Emblemas do perfil. Some por inteiro enquanto carrega e quando não há
 * emblema — um cartão não precisa avisar que alguém ainda não ganhou nada.
 */
export default class FeaturedBadges extends Component {
  userBadges = null;
  oninit(vnode) {
    super.oninit(vnode);
    loadUserBadges(this.attrs.user).then(userBadges => {
      this.userBadges = userBadges;
      m.redraw();
    });
  }
  view() {
    if (!this.userBadges?.length) return null;
    const {
      user,
      limit = 3,
      className
    } = this.attrs;
    const badges = distinctBadges(this.userBadges);
    const shown = badges.slice(0, limit);
    const more = badges.length - shown.length;
    return m("div", {
      className: classList('CanelaFeaturedBadges', className)
    }, shown.map(({
      badge,
      count
    }) => m(BadgeChip, {
      badge: badge,
      count: count,
      username: user.username()
    })), more > 0 && m(Link, {
      className: "CanelaFeaturedBadges-more",
      href: app.route('canela.user.badges', {
        username: user.slug()
      })
    }, t('badges.more', {
      count: more
    })));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/components/FeaturedBadges', FeaturedBadges);